module.exports = __webpack_public_path__ + "static/img/phynz.ec68490.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/phynz.png
// module id = x+dm
// module chunks = 1